import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import Libelle from "../../../_i18n/fr.json";
import Layout from "../../../components/Layout";
import LoadingBoundary from "../../../components/LoadingBoundary";
import { ActionCreators as AdbActionCreators } from "../../../redux/AdministrateurDeBien";
import {
  useGetAdbDetail,
  useSearchAdministrateursdeBiens,
} from "../../../hooks/AdministrateurDeBien";
import styles from "../styles";
import CriteresRecherche from "./CriteresRecherche";
import ResultatsRecherche from "./ResultatsRecherche";

export interface IProps {}

interface ICriteresRecherche {
  numAdherent?: number;
  nomAdherent?: string;
  commercial?: string;
  departement?: string;
  codePostal?: number;
  ville?: string;
  actif?: boolean;
}

interface IPagination {
  sortColumn: string;
  sortOrder: "asc" | "desc";
  page: number;
  nbrElementParPage: number;
}

const DEFAULT_NBR_ELEMENT_PAR_PAGE = 20;
const DEFAULT_SORT_ORDER = "asc";

const criteresDefaut: ICriteresRecherche = {};

const paginationDefaut: IPagination = {
  page: 0,
  nbrElementParPage: DEFAULT_NBR_ELEMENT_PAR_PAGE,
  sortColumn: "identifiant",
  sortOrder: "asc",
};

function RechercheAdbPage() {
  // searchResults: AdbSelectors.getSearchResults(state),
  // searchCount: AdbSelectors.getSearchCount(state),
  // searching: AdbSelectors.getSearchFetching(state),
  // searchError: AdbSelectors.getSearchError(state),

  const dispatch = useDispatch();
  const { mutate: mutateADBIdDetail } = useGetAdbDetail();
  const getAdbIdDetail = (params: number) => {
    mutateADBIdDetail(params);
  };
  const updateAdbId = (params: number) => {
    dispatch(AdbActionCreators.updateAdbId(params));
  };

  const [criteres, setCriteres] = useState(criteresDefaut);
  const [pagination, setPagination] = useState(paginationDefaut);

  const {
    mutate,
    data,
    isLoading: searching,
    error: searchError,
  } = useSearchAdministrateursdeBiens();

  const searchCount = data?.total || 0;
  const searchResults = data?.resultat;
  // useEffect(() => {
  //   handleRechercher();
  // }, []);

  const handleChangeCritere = (id: string, value: string | boolean) => {
    setCriteres({
      ...criteres,
      [id]: value,
    });
  };

  const handleRechercher = () => {
    // Si on lance la recherche par le bouton Rechercher (et donc changement de critères)
    // on réinitialise le numéro de page
    lancerRecherche(true);
  };

  const lancerRecherche = (resetPage: boolean) => {
    // On construit la requête de recherche en cumulant les critères de recherche
    // et les infos de pagination

    const page = resetPage ? 0 : pagination.page || 0;

    const params = {
      ...(criteres.numAdherent ? { numAdherent: criteres.numAdherent } : {}),
      ...(criteres.nomAdherent ? { nomAdherent: criteres.nomAdherent } : {}),
      ...(criteres.commercial ? { commercial: criteres.commercial } : {}),
      ...(criteres.departement ? { departement: criteres.departement } : {}),
      ...(criteres.codePostal ? { codePostal: criteres.codePostal } : {}),
      ...(criteres.ville ? { ville: criteres.ville } : {}),
      ...(criteres.actif ? { actif: criteres.actif } : {}),
      page: page,
      taille: pagination.nbrElementParPage,
      tri: `${pagination.sortColumn}:${
        pagination.sortOrder || DEFAULT_SORT_ORDER
      }`,
    };
    if (resetPage) {
      setPagination({
        ...pagination,
        page: 0,
      });
    }
    mutate(params);
  };

  const handleChangeTri = (sortColumn: string, sortOrder: "asc" | "desc") => {
    setPagination({
      ...pagination,
      sortColumn,
      sortOrder,
    });
  };

  const handleChangePage = (page: number) => {
    setPagination({ ...pagination, page });
  };

  const handleChangeNbrElementParPage = (nbrElementParPage: number) => {
    setPagination({ ...pagination, nbrElementParPage });
  };

  // numAdherent?: number;
  // nomAdherent?: string;
  // commercial?: string;
  // departement?: string;
  // codePostal?: number;
  // ville?: string;
  // actif?: boolean;
  useEffect(() => {
    lancerRecherche(false);
  }, [
    pagination.nbrElementParPage,
    pagination.page,
    pagination.sortColumn,
    pagination.sortOrder,
  ]);

  const navigate = useNavigate();
  const handleConsulter = (id: number) => {
    updateAdbId(id);
    getAdbIdDetail(id);
    navigate("/mes-administrateurs-de-biens/consulter");
  };

  const onDelete = () => {};
  const onGenerer = () => {};

  const initialValues = {
    numAdherent: criteres.numAdherent,
    nomAdherent: criteres.nomAdherent,
    commercial: criteres.commercial,
    departement: criteres.departement,
    codePostal: criteres.codePostal,
    ville: criteres.ville,
    actif: criteres.actif,
  };
  return (
    <React.Fragment>
      <Layout title={Libelle.pageRechercherAdb.titre}>
        <Box sx={styles}>
          <CriteresRecherche
            initialValues={initialValues}
            onChangeCritere={handleChangeCritere}
            onRechercher={handleRechercher}
          />
          <LoadingBoundary
            error={searchError}
            loading={searching}
            onRetry={() => lancerRecherche(true)}
          >
            {searchResults && (
              <ResultatsRecherche
                onChangeNbrElementParPage={handleChangeNbrElementParPage}
                onChangePage={handleChangePage}
                onChangeTri={handleChangeTri}
                onConsulter={handleConsulter}
                onDelete={onDelete}
                onGenerer={onGenerer}
                searchResults={searchResults}
                searchCount={searchCount}
                nbrElementParPage={pagination.nbrElementParPage}
                sortColumn={pagination.sortColumn}
                sortOrder={pagination.sortOrder}
                page={pagination.page}
              />
            )}
          </LoadingBoundary>
        </Box>
      </Layout>
    </React.Fragment>
  );
}

export default RechercheAdbPage;
